module.exports = __webpack_public_path__ + "static/media/icons-yc-vrmode.c8cc40c8.svg";